import React from 'react';
import PropTypes from 'prop-types';
import conversationStatuses from 'enums/conversationStatuses';
import { makeStyles } from 'styles/util';

import Form from 'form/Form';
import AdminFormFields from 'admin/presentational/AdminFormFields';
import ReadOnlyField from 'admin/presentational/ReadOnlyField';
import AdminFormButtons from 'admin/presentational/AdminFormButtons';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import SendMessageFormFields from 'admin/containers/sendMessage/SendMessageFormFields';
import MenuItem from '@material-ui/core/MenuItem';
import { TextField, Checkboxes } from 'mui-rff';

const useStyles = makeStyles(({ theme }) => ({
    additionalFieldsContainer: {
        marginTop: theme.spacing(2),
        display: 'flex',
        gap: theme.spacing(2),
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        },
        '& > *': {
            flex: '0 0 50%'
        }
    }
}));

const SendMessageForm = ({ conversation, predefinedTexts, onSubmit }) => {
    const classes = useStyles();

    const initialValues = {
        senderActorId: '' + (conversation.lastSenderIsOwner ? conversation.tenantActor.id : conversation.ownerActor.id),
        sendAsAdmin: false,
        body: predefinedTexts.find(o => o.key === 'DefaultFooter')?.text ?? '',
        status: conversation.status,
        sendSms: false
    };

    return (
        <Form
            initialValues={initialValues}
            onSubmit={onSubmit}
        >
            {({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit}>
                    <AdminFormFields>
                        <ReadOnlyField label="">
                            <Typography variant="h5">
                                Send message
                            </Typography>
                        </ReadOnlyField>

                        <SendMessageFormFields
                            tenantActor={conversation.tenantActor}
                            ownerActor={conversation.ownerActor}
                            predefinedTexts={predefinedTexts}
                        />

                        <Box className={classes.additionalFieldsContainer}>
                            <Box>
                                <TextField
                                    select
                                    name="status"
                                    label="New status"
                                    variant="outlined"
                                >
                                    {
                                        Object.values(conversationStatuses).map(o => (
                                            <MenuItem key={o.key} value={o.key}>
                                                {o.title}
                                            </MenuItem>
                                        ))
                                    }
                                </TextField>
                            </Box>
                            <Box>
                                <Checkboxes
                                    name="sendSms"
                                    data={
                                        { label: 'Also notify by SMS', value: true }
                                    }
                                />
                            </Box>
                        </Box>
                    </AdminFormFields>
                    <AdminFormButtons>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={invalid}
                        >
                            Send
                        </Button>
                    </AdminFormButtons>
                </form>
            )}
        </Form>
    );
};

SendMessageForm.propTypes = {
    conversation: PropTypes.object.isRequired,
    predefinedTexts: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default SendMessageForm;
